// extracted by mini-css-extract-plugin
export default {"wrapper":"empty_wrapper__VSAwY","container":"empty_container__Dt83c","title":"empty_title__fz-0-"};